export const AppConfig = {
    API_BASE_URL: "https://icg-uat-api.4seeanalytics.com/api/"
};

export default AppConfig;
